import { Route } from 'react-router-dom';
import { paramsFromURL } from 'utils/paramHelpers';
import { routes } from 'controllers';
import { AuthRoute } from 'components/generic/AuthRoute';

const makeRoutes = (token, redirect) => {
  return routes?.map((route, index) => {
    const { path, element, authenticate } = route;

    const authElement = (
      <AuthRoute
        token={token}
        redirect={redirect}
        from={{ pathname: path, search: paramsFromURL() }}
      />
    );

    if (authenticate) {
      return (
        <Route key={index} element={authElement}>
          <Route path={path} element={element} />
        </Route>
      );
    }

    return <Route key={index} path={path} element={element} />;
  });
};

export { makeRoutes };